import { Space } from 'antd';
import { observer } from 'mobx-react-lite';

import * as PageNotifications from 'app/common/notifications/features/page-notifications';
import { PageContent } from 'app/ui';

import { CurrentUserProfile } from './current-user-profile';

export const CurrentUserPage = observer(() => {
  return (
    <PageNotifications.Provider>
      <PageContent>
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
          <PageNotifications.Render>
            {(messages) => messages}
          </PageNotifications.Render>

          <CurrentUserProfile />
        </Space>
      </PageContent>
    </PageNotifications.Provider>
  );
});
